import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/" onClick={() => handleNavigation('/')}>
            <img src={logo} alt="Lingify Logo" />
          </Link>
        </div>

        {/* Mobil Menü Butonu */}
        <button className="mobile-menu-btn" onClick={toggleMenu}>
          {isMenuOpen ? '✕' : '☰'}
        </button>

        {/* Navigasyon Menüsü */}
        <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            onClick={() => handleNavigation('/')}
          >
            Ana Sayfa
          </Link>
          <Link
            to="/hakkimizda"
            className={`nav-link ${location.pathname === '/hakkimizda' ? 'active' : ''}`}
            onClick={() => handleNavigation('/hakkimizda')}
          >
            Hakkımızda
          </Link>
          <Link
            // to="/nasil-calisir"
            // className={nav-link ${location.pathname === '/nasil-calisir' ? 'active' : ''}}
            // onClick={() => handleNavigation('/nasil-calisir')}
            to="#"
            className="nav-link disabled-link"
            onClick={(e) => e.preventDefault()}
          >
            Nasıl Çalışır?
          </Link>

          <Link
            // to="/blog"
            // className={`nav-link ${location.pathname === '/blog' ? 'active' : ''}`}
            // onClick={() => handleNavigation('/blog')}
            to="#"
            className="nav-link disabled-link"
            onClick={(e) => e.preventDefault()}
          >
            Blog
          </Link>
          <Link
            to="/iletisim"
            className={`nav-link ${location.pathname === '/iletisim' ? 'active' : ''}`}
            onClick={() => handleNavigation('/iletisim')}
          >
            İletişim
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
